export const phoneNumberPattern = "+?[0-9]{6,13}$";
export const namePattern = "[a-zA-Z]+";
export const numberPattern = "[0-9]+";